import Service from './Service'
import moment from 'moment'

class Products extends Service {
    /** @type {Object} */
  cachedProducts

    /** @type {moment} */
  productsCacheTimes

  constructor (connection, cacheTimeNormal) {
    super(connection, cacheTimeNormal)
    this.cachedProducts = {}
    this.productsCacheTimes = {}
  }

  get (params) {
    params.request = 'getProducts'

    return this.fetchAllRecords('', params)
      .catch(response => this.handleErrorResponse(response))
  }

  getSome (params, count) {
    if (typeof params.codePrefix !== 'undefined' && this.cachedProducts['search-' + (params.codePrefix ? params.codePrefix : 'all')] &&
        moment().diff(this.productsCacheTimes['search-' + (params.codePrefix ? params.codePrefix : 'all')], 'seconds') < this.cacheTimeNormal) {
      return Promise.resolve(this.cachedProducts['search-' + (params.codePrefix ? params.codePrefix : 'all')])
    }
    params.request = 'getProducts'
    params.recordsOnPage = count

    return this.connection.postErply(params)
      .then(response => {
        if (typeof params.codePrefix !== 'undefined') {
          this.cachedProducts['search-' + (params.codePrefix ? params.codePrefix : 'all')] = response.data.records
          this.productsCacheTimes['search-' + (params.codePrefix ? params.codePrefix : 'all')] = moment()
        }

        return this.handleMultiRecordResponse(response)
      })
      .catch(response => this.handleErrorResponse(response))
  }

  getByIds (ids) {
    if (ids.length === 0) {
      return Promise.resolve([])
    }

    return this.get({productIDs: ids.join(',')})
  }

  getProducts (id) {
    return this.connection.get('events/' + id + '/pricelist-products', {})
          .then(response => {
            return response.data.records
          })
          .catch(response => this.handleErrorResponse(response))
  }

  remove (id, product) {
    let request = 'events/' + id + '/pricelist-products/' + product.priceListProductId
    return this.connection.requestSpea(request, {mode: 'delete'})
      .then(response => {
        this.cachedProducts[id] = []
        this.productsCacheTimes[id] = []
        return this.handleEmptyResponse(response)
      })
      .catch(response => this.handleErrorResponse(response))
  }

  edit (id, product) {
    let request = 'events/' + id + '/pricelist-products/' + product.priceListProductId
    product.mode = 'patch'
    return this.connection.requestSpea(request, product)
        .then(response => {
          this.cachedProducts[id] = []
          this.productsCacheTimes[id] = []
          return this.handleEmptyResponse(response)
        })
        .catch(response => this.handleErrorResponse(response))
  }

  addProduct (id, product) {
    product.mode = 'post'
    return this.connection.requestSpea('events/' + id + '/pricelist-products', product)
    .then(response => {
      this.cachedProducts[id] = []
      this.productsCacheTimes[id] = []
      return response
    })
  }
}
export default Products



// WEBPACK FOOTER //
// ./src/api/Service/Products.js